import {
  AdminHeader,
  AdminSpinner,
  ListSpinner,
  QueryStatus,
  SearchInput,
  Tab,
  TabsWrapper,
  handleSetUrlSearchParams,
  restaurantImage,
} from '@vgrubs/components';
import { NoDataComponent } from 'components/src/adminComponents/NoDataComponent/NoDataComponent';
import { useSearchParams } from 'react-router-dom';
import { LocationComponent } from './LocationComponent';
import { useAdminLocationsInfiniteScroll } from './hooks/useAdminLocationsInfiniteScroll';

enum LocationActiveStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export const Locations = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialQuery = searchParams.get('query') || '';

  const setActiveStatus = (status: LocationActiveStatus) => {
    handleSetUrlSearchParams('status', status, setSearchParams);
  };

  const activeStatus =
    searchParams.get('status') || LocationActiveStatus.ACTIVE;

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleInputChange(e);
    handleSetUrlSearchParams('query', e.target.value, setSearchParams);
  };

  const {
    locations,
    inputValue,
    handleInputChange,
    observerRef,
    isFetchingNextPage,
    status,
    saveScrollPosition,
    nonDeletedCount,
    deletedCount,
    totalCount,
  } = useAdminLocationsInfiniteScroll({
    initialQuery,
    deleted: activeStatus === LocationActiveStatus.INACTIVE,
  });

  return (
    <>
      <AdminHeader
        title={`Locations (${
          totalCount ? totalCount + (initialQuery ? 0 : 3000) : 0
        })`}
      >
        <SearchInput
          value={inputValue}
          maxWidth="350px"
          maxWidthSM="160px"
          placeholder="Search Location"
          onChange={onSearchChange}
        />
      </AdminHeader>

      <TabsWrapper>
        <Tab
          $widthSM="calc(50% - 6px)"
          selected={activeStatus === LocationActiveStatus.ACTIVE}
          onClick={() => setActiveStatus(LocationActiveStatus.ACTIVE)}
        >
          Active (
          {nonDeletedCount ? nonDeletedCount + (initialQuery ? 0 : 3000) : 0})
        </Tab>
        <Tab
          $widthSM="calc(50% - 6px)"
          selected={activeStatus === LocationActiveStatus.INACTIVE}
          onClick={() => setActiveStatus(LocationActiveStatus.INACTIVE)}
        >
          Inactive ({deletedCount ?? 0})
        </Tab>
      </TabsWrapper>

      {locations.map((location) => (
        <LocationComponent
          key={location.id}
          location={location}
          onBeforeNavigate={saveScrollPosition}
        />
      ))}

      {locations.length === 0 &&
        status !== QueryStatus.PENDING &&
        !isFetchingNextPage && (
          <NoDataComponent
            image={restaurantImage}
            title="No Locations"
            description="No locations found"
          />
        )}

      <ListSpinner loading={isFetchingNextPage} observerRef={observerRef} />
      {status === QueryStatus.PENDING && <AdminSpinner />}
    </>
  );
};
